export const dimensions = ['product', 'fact', 'market', 'period'];
